<template>
    <div>
        <span class="label label-warning d-inline-block mr-2 pl-2 pr-2 mb-0">
            Up to <strong>{{numberImageThreshold}}</strong> images
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            element: {
                type: Object,
                default() {
                    return null;
                },
            }
        },
        watch: {
            element() {
                this.numberImageThreshold = parseInt(this.element.serviceDetails);
            }
        },
        data() {
            return {
                numberImageThreshold: 1,
            };
        },
        created() {
            this.numberImageThreshold = parseInt(this.element.serviceDetails);
        }
    };
</script>